@let user = isAuthenticated$ | async;
@let settingsError = settingsError$ | async;
<main>
  @if (user && settingsError !== null) {
    <section class="settings-error" role="alert">
      <h1>Não foi possível abrir a Bidscircle</h1>
      <p>{{ settingsErrorMessage(settingsError) }}</p>
      <div class="settings-error__actions">
        @if (isSso && portalUrl) {
          <a mat-flat-button color="primary" [href]="portalUrl">Voltar ao portal</a>
        }
        <button mat-stroked-button type="button" (click)="onLogout()">Terminar sessão</button>
      </div>
    </section>
  } @else {
    @if (user) {
      <app-impersonation-banner></app-impersonation-banner>
      <app-header
        (loggedOut)="onLogout()"
        [settings]="userSettings$ | async"
      ></app-header>
    }
    <router-outlet></router-outlet>
  }
</main>
